export const getCurrencySymbol =(code)=>{
  switch (code) {
    case 'usd':
      return '$';
    case 'eur':
      return '€';
    case 'gbp':
      return '£';
    default:
      return code;
  }
}